import AxiosInstance from 'src/shared/services/axios/interceptor';

export interface PostCodeLookup {
  postnr: string;
  ort: string;
  kommunkod: string;
  lanskod: string;
}

const controller = 'Address';

// Slår upp ort/kommunkod/länskod för ett postnummer (för auto-ifyllnad i formulär).
// skipErrorToast: ett okänt postnummer ger 404 men ska inte visa någon fel-toast.
export const getPostCode = (postnr: string) => {
  const clean = (postnr ?? '').replace(/\s/g, '');
  return AxiosInstance.get<PostCodeLookup>(`${controller}/PostCode/${clean}`, { skipErrorToast: true });
};
